import { createAction } from '@reduxjs/toolkit'
export const UPDATE_CARD_DATA = 'card/UPDATE_CARD_DATA'

export const updateCardData = createAction(UPDATE_CARD_DATA)
